import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonDatetime,
  IonHeader,
  IonIcon,
  IonPopover,
  IonSegment,
  IonSegmentButton,
  IonTitle,
  IonToolbar,
  ModalController,
} from '@ionic/angular/standalone';
import { SuperButtonComponent } from '@qid/super';

export type OrdersStatusSegment = 'all' | 'completed' | 'pending';

export interface OrdersFilterValue {
  statusSegment: OrdersStatusSegment;
  startDate: string;
  endDate: string;
  conflictOnly: boolean;
  razorpayOnly: boolean;
}

@Component({
  selector: 'app-orders-filter',
  templateUrl: './orders-filter.component.html',
  styleUrls: ['./orders-filter.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonContent,
    IonIcon,
    IonDatetime,
    IonPopover,
    IonSegment,
    IonSegmentButton,
    SuperButtonComponent,
  ],
})
export class OrdersFilterComponent implements OnInit {

  @Input() filters: OrdersFilterValue = {
    statusSegment: 'all',
    startDate: '',
    endDate: '',
    conflictOnly: false,
    razorpayOnly: false,
  };

  public statusSegment: OrdersStatusSegment = 'all';
  public startDate = '';
  public endDate = '';
  public conflictOnly = false;
  public razorpayOnly = false;

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    this.statusSegment = this.filters?.statusSegment ?? 'all';
    this.startDate = this.filters?.startDate ?? '';
    this.endDate = this.filters?.endDate ?? '';
    this.conflictOnly = !!this.filters?.conflictOnly;
    this.razorpayOnly = !!this.filters?.razorpayOnly;
  }

  public get todayIso(): string {
    return new Date().toISOString();
  }

  public get hasActiveFilters(): boolean {
    return this.statusSegment !== 'all' || !!this.startDate || !!this.endDate || this.conflictOnly || this.razorpayOnly;
  }

  close = async () => {
    await this.modalController.dismiss();
  };

  onStartDate(event: any) {
    this.startDate = event?.detail?.value || '';
  }

  onEndDate(event: any) {
    this.endDate = event?.detail?.value || '';
  }

  clearStartDate() {
    this.startDate = '';
  }

  clearEndDate() {
    this.endDate = '';
  }

  clearAll = async () => {
    this.statusSegment = 'all';
    this.startDate = '';
    this.endDate = '';
    this.conflictOnly = false;
    this.razorpayOnly = false;
  };

  apply = async () => {
    const filters: OrdersFilterValue = {
      statusSegment: this.statusSegment,
      startDate: this.startDate,
      endDate: this.endDate,
      conflictOnly: this.conflictOnly,
      razorpayOnly: this.razorpayOnly,
    };
    await this.modalController.dismiss({ applied: true, filters });
  };
}
